// web/src/components/common/AuthModals.jsx
import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";

function Sheet({ open, onClose, title, children }){
  if (!open) return null;
  return (
    <div role="dialog" aria-modal="true" onClick={onClose}
         style={{position:"fixed", inset:0, zIndex:10001, background:"rgba(0,0,0,.45)", display:"grid", placeItems:"center"}}>
      <div onClick={e=>e.stopPropagation()}
           style={{background:"#fff", borderRadius:16, padding:18,
                   border:"1px solid rgba(0,0,0,0.06)", boxShadow:"0 18px 48px rgba(0,0,0,0.20)"}}>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
          <h3 style={{margin:"4px 0 10px", fontSize:18}}>{title}</h3>
          <button onClick={onClose}
                  className="btn btn-light"
                  title="Fermer"
                  style={{padding:"6px 10px"}}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

/* ------------------- Login ------------------- */
export function LoginModal({ open, onClose, onOpenSignup, onOpenReset }){
  const { login } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr]   = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    const form = new FormData(e.currentTarget);
    const email = String(form.get("email")||"").trim();
    const pass  = String(form.get("password")||"");
    if (!email || !pass) { setErr("Email et mot de passe requis."); return; }
    try {
      setBusy(true);
      await login(email, pass);
      onClose?.();
    } catch (e2) {
      setErr("Identifiants invalides.");
    } finally { setBusy(false); }
  };

  return (
    <Sheet open={open} onClose={onClose} title="Se connecter">
      <form onSubmit={onSubmit}>
        <label>Email</label>
        <input name="email" type="email" autoComplete="email" />
        <label>Mot de passe</label>
        <input name="password" type="password" autoComplete="current-password" />
        {err && <div style={{color:"#b91c1c", fontWeight:700, marginBottom:8}}>{err}</div>}

        {/* Row: Se connecter (left) | Créer + Oublié (right) */}
        <div style={{display:"flex", gap:8, justifyContent:"space-between", alignItems:"center"}}>
          <button className="btn btn-primary" disabled={busy}>{busy ? "Connexion…" : "Se connecter"}</button>
          <div style={{display:"flex", gap:8}}>
            <button type="button" className="btn btn-success" onClick={onOpenSignup}>Créer un compte</button>
            <button type="button" className="btn btn-light" onClick={onOpenReset}>Mot de passe oublié</button>
          </div>
        </div>
      </form>
    </Sheet>
  );
}

/* ------------------- Signup ------------------- */
export function SignupModal({ open, onClose, onOpenLogin }){
  const { signup } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr]   = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    const form = new FormData(e.currentTarget);
    const email = String(form.get("email")||"").trim();
    const name  = String(form.get("name")||"").trim();
    const pass  = String(form.get("password")||"");
    if (!email || !name || !pass) { setErr("Tous les champs sont requis."); return; }
    if (pass.length < 8) { setErr("Mot de passe trop court (min 8)."); return; }
    try {
      setBusy(true);
      await signup(email, name, pass);
      onClose?.();
    } catch (e2) {
      setErr("Inscription impossible (email déjà utilisé ?).");
    } finally { setBusy(false); }
  };

  return (
    <Sheet open={open} onClose={onClose} title="Créer un compte">
      <form onSubmit={onSubmit}>
        <label>Nom d'utilisateur</label>
        <input name="name" />
        <label>Email</label>
        <input name="email" type="email" autoComplete="email" />
        <label>Mot de passe</label>
        <input name="password" type="password" autoComplete="new-password" />
        {err && <div style={{color:"#b91c1c", fontWeight:700, marginBottom:8}}>{err}</div>}
        <div style={{display:"flex", gap:8, justifyContent:"flex-end"}}>
          <button type="button" className="btn btn-light" onClick={onOpenLogin}>J’ai déjà un compte</button>
          <button className="btn btn-success" disabled={busy}>{busy ? "Création…" : "Créer un compte"}</button>
        </div>
      </form>
    </Sheet>
  );
}

/* ------------------- Forgot ------------------- */
export function ForgotModal({ open, onClose }){
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr]   = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    const form = new FormData(e.currentTarget);
    const email = String(form.get("email")||"").trim();
    if (!email) { setErr("Email requis."); return; }
    try {
      setBusy(true);
      await fetch("/api/auth/request-password-reset", {
        method: "POST",
        headers: { "Content-Type":"application/json" },
        body: JSON.stringify({ email }),
        credentials: "include",
      });
      setDone(true);
    } catch (e2) {
      setErr("Impossible d'envoyer l’e-mail.");
    } finally { setBusy(false); }
  };

  return (
    <Sheet open={open} onClose={onClose} title="Mot de passe oublié">
      {!done ? (
        <form onSubmit={onSubmit}>
          <label>Email</label>
          <input name="email" type="email" autoComplete="email" />
          {err && <div style={{color:"#b91c1c", fontWeight:700, marginBottom:8}}>{err}</div>}
          <div style={{display:"flex", gap:8, justifyContent:"flex-end"}}>
            <button className="btn btn-light" disabled={busy}>{busy ? "Envoi…" : "Envoyer le lien"}</button>
          </div>
        </form>
      ) : (
        <div>
          <p>Si un compte existe pour cet e-mail, un lien de réinitialisation a été envoyé.</p>
          <div style={{display:"flex", justifyContent:"flex-end"}}>
            <button className="btn btn-light" onClick={onClose}>Fermer</button>
          </div>
        </div>
      )}
    </Sheet>
  );
}
